import types from './types';

export const state = {
  active: {},
};

export const mutations = {
  [types.SET_ACTIVE_NOTE](state, note) {
    state.active = note;
  },
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Notes/store/mutations.js